import React from 'react';
import { Lesson } from '../../../../../ui/src/models/book/bookModel';

const SachMemLesson: React.FC<{ lesson: Lesson; index: number }> = ({
  lesson,
  index,
}) => {
  return (
    <div className={`lesson lesson-index-${index}`}>
      <div className="text-center">
        <div className="lesson-name">{lesson.name}</div>
      </div>
      <div className="lesson-section">
        {lesson.sections.map((s) =>
          s.sectionGames.map((game, i) => (
            <div
              key={i}
              className="lesson-item pointer-cursor"
              onClick={() => {
                window.open(game.link, '_blank');
              }}>
              <div className="item-index">{i + 1}</div>
              <div className="item-name">{game.name}</div>
            </div>
          )),
        )}
      </div>
    </div>
  );
};

export default SachMemLesson;
